'use strict';
define(function () {

    var utils = {
        hasTouchCapability: function () {
            return (document.querySelector('html.touch') !== null);
        },

        preventClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        },

        hasClass: function (element, className) {
            if(element){
                return new RegExp(' ' + className + ' ').test(' ' + element.className + ' ');
            }
            return false;
        },

        addClass: function (element, className) {
            var hasClass = utils.hasClass(element, className);
            if (!hasClass) {
                element.className += ' ' + className;
            }
        },

        removeClass: function (element, className) {
            var hasClass = utils.hasClass(element, className);
            if (hasClass) {
                var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                element.className = element.className.replace(reg, ' ');
            }
        },

        /**
         * @param {Object} obj key values to construct string
         * @returns {string/Boolean}
         */
        serialize: function (obj) {
            var str = [];

            if (typeof obj !== 'object' || Array.isArray(obj)) {
                return false;
            }

            for (var p in obj) {
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                }
            }

            return str.join('&');
        },

        /**
         * @param host {string}
         * @param params {object}
         * @returns {string}
         */
        constructUrl: function (host, params) {
            var parts = [];

            if (typeof host !== 'string') {
                return '';
            }

            parts.push(host);

            if (utils.serialize(params)) {
                parts.push(utils.serialize(params));
            }

            return parts.join('?');
        },

        /**
         * Append the current url to the target url
         * @param {String} targetUrl
         * @param {String} sourceUrl
         * @returns {String}
         */
        appendSourceUrl: function (targetUrl, sourceUrl) {
            if (typeof targetUrl !== 'string' || typeof sourceUrl !== 'string') {
                return '/';
            }
            if (targetUrl.indexOf('sourceurl') === -1) {
                sourceUrl = decodeURIComponent(sourceUrl);
                if (targetUrl.indexOf('?') === -1) {
                    targetUrl += '?';
                } else {
                    if (targetUrl.indexOf('?') !== (targetUrl.length - 1)) {
                        targetUrl += '&';
                    }
                }
                return targetUrl + 'sourceurl=' + encodeURIComponent(sourceUrl);
            } else {
                return targetUrl;
            }
        },

        /**
         * Set a group of DOM elements' tabindex
         * @param {DOM object} els
         * @param {Integer} tabindex
         */
        setTabIndex: function (els, tabindex) {
            for (var i = 0; i < els.length; i++) {
                els[i].setAttribute('tabindex', tabindex);
            }
        },

        checkIeVersion: function () {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }
    };

    return utils;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/util.js